import React from 'react'
import get from 'lodash/get'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Swiper, SwiperSlide } from 'swiper/react'

export interface LiveData {
  room_id: string
  preview_id: string
  type: 0 | 1 | 2
  title: string
  create_time: number
  finish_time: number
  cover_url: string
  popularity: number
  user_info: {
    user_name: string
    avatar: string
    user_id_str: string
  }
}
interface IProps {
  children?: React.ReactNode
  imgArray: string[]
  room_ids: string[]
  setSlideIndex?: (x: number) => void
  show_home_live_banner_tea?: (x: number) => void
}

const left_ic_img = require('static/left-ic.png')

export default function ToggleImageGroup(props: IProps) {
  const {
    children,
    imgArray,
    setSlideIndex,
    show_home_live_banner_tea,
    room_ids,
  } = props

  const params = {
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.banner-nav-next',
      prevEl: '.banner-nav-pre',
    },
    loop: true,
    onSlideChangeTransitionStart() {
      const activeIndex = get(this, 'activeIndex', 1) - 1 + imgArray.length
      setSlideIndex && setSlideIndex(activeIndex % imgArray.length)
      show_home_live_banner_tea &&
        show_home_live_banner_tea(activeIndex % imgArray.length)
    },
  }
  const imgGroup = imgArray.map((e, index) => (
    <SwiperSlide key={e + index}>
      <a
        // eslint-disable-next-line react/jsx-no-target-blank
        target="_blank"
        href={`https://live.ixigua.com/room/${room_ids[index]}/`}
      >
        <img src={e} className="live-img" />
        <style jsx>
          {`
            .live-img {
              width: 380px;
              height: 214px;
              display: inline-block;
              object-fit: cover;
              object-position: center;
            }
          `}
        </style>
      </a>
    </SwiperSlide>
  ))
  return (
    <>
      <div className="toggle-image-group">
        <Swiper {...params}>
          {imgGroup}
          <div className="banner-nav-pre swiper-nav-pre tw-inline-block" />
          <div className="banner-nav-next swiper-nav-next tw-inline-block" />
        </Swiper>
        {children}
      </div>
      <style jsx>
        {`
          .toggle-image-group{
            position: relative;
            width: 380px;
            height: 214px;
            overflow: hidden;
          }          :global(.live-img:hover){
            transform: scale(1.1);
          }
          :global(.live-img){
            transition: transform ease-in-out .3s;
          }
          

          :global(.toggle-image-group .swiper-button-prev, .toggle-image-group .swiper-button-next) {
            background-color: rgba(0, 0, 0, .4);
            opacity: 1;
            width: 32px;
            height: 48px;
            border-radius: 8px;
            margin-top: -24px;
          }
          :global(.toggle-image-group .swiper-button-prev){
            border-radius: 0 8px 8px 0;
          }
          :global(.toggle-image-group .swiper-button-next){
            border-radius: 8px 0 0 8px;
          }
          :global(.toggle-image-group .swiper-button-prev::after, .toggle-image-group .swiper-button-next::after) {
            width: 24px;
            height: 24px;
            margin-top: 0;
            transform: translateY(-50%);
            margin-left: -12px;
            background-image: url('${left_ic_img}');
          }
          :global(.toggle-image-group .swiper-button-prev:hover, .toggle-image-group .swiper-button-next:hover) {
            opacity: 1;
            background-color: #f5b330;
            margin-top: -24px;
          }

          :global(.toggle-image-group .swiper-button-prev:hover::after, .toggle-image-group .swiper-button-next:hover::after) {
            background-image: url('${left_ic_img}');
          }

          :global(.toggle-image-group .swiper-button-next:after, .toggle-image-group .swiper-button-next:hover::after){
            transform: translateY(-50%) rotate(180deg);
          }
        `}
      </style>
    </>
  )
}
